import _extends from "/src/main/react/node_modules/@babel/runtime/helpers/esm/extends.js";
var _jsxFileName = "/src/main/react/src/main/app/components/common/HomeButton.js";
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { SvgIcon, Button } from '@material-ui/core';
import { HOMEPAGE } from "../Routes";
const styles = () => ({});

/**
 * A button which always redirects to the homepage (/)
 */
class HomeButton extends Component {
  constructor(props) {
    super(props);
    this.routeHome = this.routeHome.bind(this);
  }
  routeHome() {
    this.props.history.push(HOMEPAGE);
  }
  render() {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: () => this.routeHome(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 24,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(SvgIcon, _extends({}, this.props, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 21
      }
    })));
  }
}
export default withStyles(styles)(withRouter(HomeButton));